import {
  Component,
  computed,
  effect,
  inject,
  Input,
  model,
  OnDestroy,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AttributeInterface,
  ProductInterface,
  ProviderProductInterface,
} from '../../../../core/interfaces/product/product';
import {
  FieldsPipePipe,
  ProviderGroupEnum,
  providerSettingsInterface,
} from '@component-library';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormsModule } from '@angular/forms';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BrandSelectionComponent } from '../../../brands/brand-selection/brand-selection.component';
import { ProviderBrandsSearchResponseData } from '../../../../core/interfaces/blog/provider-brands-search';
import { ProviderCategoriesGetResponseItemsInterface } from '../../../../core/interfaces/categories/provider-categories-interface';
import { ProviderCategoriesService } from '../../../../core/services/categories/provider-categories.service';
import { CategoriesSelectionComponent } from '../../../categories/categories-selection/categories-selection.component';
import { ProviderCategoryAttributesService } from '../../../../core/services/categories/provider-category-attributes.service';
import { RedisProviderCategoryAttributeRootInterface } from '../../../../core/interfaces/categories/provider-category-attributes-interface';
import { CategoryAttributesMatchingComponent } from '../../../categories/category-attributes-matching/category-attributes-matching.component';
import {
  ProviderProductAttribute,
  ProviderProductClass,
} from '../../../../core/classes/provider-product/provider-product';
import { StoreInterface } from '../../../../core/interfaces/store/store-interface';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { MessagesModule } from 'primeng/messages';

import { ChipModule } from 'primeng/chip';
import { DividerModule } from 'primeng/divider';
import { TooltipModule } from 'primeng/tooltip';
import { AttributeKeyFindPipe } from '../pipes/attribute-key-find.pipe';
import { StoreService } from '../../../../core/store/store.service';
import { LocalStorageService } from '../../../../core/services/storage/local-storage.service';
import { providerAttributeEditFunction } from '../../functions/provider-attribute-edit-function';
import { Message } from 'primeng/message';
import {
  getStoreBrandMapping,
  getStoreCategoryMapping,
} from '../../functions/get-mappings-function';
import { prepareAttributes } from '../../functions/prepare-attributes-function';

@Component({
  selector: 'magenty-provider-product-detail-matching',
  imports: [
    CommonModule,
    FieldsPipePipe,
    ButtonModule,
    InputNumberModule,
    FormsModule,
    MessagesModule,
    ChipModule,
    DividerModule,
    TooltipModule,
    AttributeKeyFindPipe,
    Message,
  ],
  providers: [DialogService],
  templateUrl: './provider-product-detail-matching.component.html',
  styleUrl: './provider-product-detail-matching.component.scss',
})
export class ProviderProductDetailMatchingComponent
  implements OnInit, OnDestroy
{
  storeService = inject(StoreService);
  @Input() product: ProductInterface | undefined;
  @Input() providerProduct: ProviderProductInterface = new ProviderProductClass(
    this.storeService.store$()
  );
  @Input() providerSettings: providerSettingsInterface | undefined;
  store: StoreInterface;
  brandSelectionRef: DynamicDialogRef | undefined;
  categorySelectionRef: DynamicDialogRef | undefined;
  categoryAtrributeRef: DynamicDialogRef | undefined;
  private destroy$ = new Subject<void>();
  providerCategoryAttributes = model<
    RedisProviderCategoryAttributeRootInterface[]
  >([]);

  categoryAttributesMatching: WritableSignal<boolean> = signal(false);
  validationSetTimeId: any;

  matchingAutoComplete = model({
    brand: false,
    category: false,
    attribute: false,
    variant: false,
  });

  providerCategory: ProviderCategoriesGetResponseItemsInterface = {
    Name: '',
    Code: '',
    Path: '',
    PathBuild: [],
  };
  messages: { severity: string; detail: string }[] = [];

  newAttributes$ = model();
  subscription: Subscription | undefined;
  filteredAttributes:ProviderProductAttribute[] = [];
  emptyValueAttributes=false

  constructor(
    public ref: DynamicDialogRef,
    private providerCategoryAttributesService: ProviderCategoryAttributesService,
    private dialogService: DialogService,
    private providerCategoriesService: ProviderCategoriesService,
    private localStorageService: LocalStorageService
  ) {
    this.store = this.storeService.store$();
    effect(() => {
      this.store = this.storeService.store$();
    });
    computed(() => {
      let result = false;
      if (this.providerProduct) {
        result = this.providerProduct.Attributes.every(
          (attribute: AttributeInterface) => {
            attribute.Values.every((values) =>
              this.providerCategoryAttributes()?.find((f) =>
                f.Values.includes({
                  Value: values.Value,
                  Key: values.Key,
                  lowercaseValue: values.Value,
                })
              )
            );
          }
        );
      }

      this.categoryAttributesMatching.set(result);
      this.validation();
    });
  }

  checkAttributes = () => {
    if (!this.providerProduct || this.providerProduct.Attributes.length === 0) {
      return;
    }

    this.providerProduct.Attributes.map((data) => {
      const foundAttributes = this.providerCategoryAttributes().find(
        (providerAttributes) => providerAttributes.Code === data.Code
      );
      if (
        foundAttributes &&
        foundAttributes.Values.length > 0 &&
        data.Value &&
        data.Value.length > 0
      ) {
        const found = foundAttributes.Values.find(
          (f) => f.Value.toLocaleLowerCase() === data.Value?.toLocaleLowerCase()
        );

        data.IsFaulty = !found;
      }
    });

    this.filteredAttributes=this.providerProduct.Attributes.filter(f=>f.Value && f.Value.length>0);
    this.emptyValueAttributes=this.providerProduct.Attributes.every(f=>!f.Compulsory && (!f.Value || f.Value.length===0));
    this.validation();
  };

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.subscription?.unsubscribe();
  }

  messagesFill = () => {
    const { brand, category, attribute } = this.matchingAutoComplete() ?? {
      brand: false,
      category: false,
      attribute: false,
    };
    let detail = '';

    if (brand) {
      detail += 'Marka';
    }
    if (brand && category) {
      detail += ' , ';
    }
    if (category) {
      detail += 'Kategori';
    }
    if (category && attribute) {
      detail += ' ve ';
    }
    if (attribute) {
      detail += 'Kategori Özellikleri';
    }
    if (brand || category || attribute) {
      detail += ' Otomatik Olarak Eşleştirildi.';

      this.messages = [];

      this.messages.push({
        severity: 'success',
        detail,
      });
    }
  };

  ngOnInit() {
    this.matchingAutoComplete.set({
      ...this.matchingAutoComplete(),
      brand: false,
      category: false,
      attribute: false,
    });

    if (this.providerProduct.Id.length === 0) {
      this.autoBrandMatching();
      this.autoCategoryMatching();

      return;
    }

    if (this.providerSettings?.category.supporting) {
      this.providerCategoriesGetRequest(this.providerProduct?.Category ?? '');
    }
  }

  autoBrandMatching = () => {
    if (
      !this.providerSettings?.brand.supporting ||
      this.providerProduct.getBrandId().length > 0
    ) {
      return;
    }

    const storeBrandMapping = getStoreBrandMapping(
      this.store,
      this.product?.BrandId ?? '',
      this.providerProduct.MarketplaceIdentity,
      this.providerProduct.ProviderId
    );

    if (storeBrandMapping) {
      this.providerProduct?.setBrandName(
        storeBrandMapping?.Attribute?.Value ?? ''
      );
      this.providerProduct?.setBrandId(
        storeBrandMapping?.Attribute?.Name ?? ''
      );

      this.matchingAutoComplete().brand = true;
    }

    this.messagesFill();
    this.validation();
  };

  autoCategoryMatching = () => {
    if (!this.providerSettings?.category.supporting) {
      return;
    }

    if (this.providerProduct.Category.length === 0) {
      const storeFoundCategoryMapping = getStoreCategoryMapping(
        this.store,
        this.product?.CategoryId ?? '',
        this.providerProduct.MarketplaceIdentity,
        this.providerProduct.ProviderId
      );

      if (storeFoundCategoryMapping) {
        this.providerCategory.Code = storeFoundCategoryMapping.ProviderCategory;
        this.providerCategory.Path =
          storeFoundCategoryMapping.ProviderCategoryName;

        this.providerProduct.Category =
          storeFoundCategoryMapping?.ProviderCategory;

        this.matchingAutoComplete().category = true;
      }
    }

    if (this.providerSettings) {
      this.providerCategoriesGetRequest(this.providerProduct.Category);
    }

    this.messagesFill();
    this.validation();
  };

  autoAttributeMatching = (
    attributeList: RedisProviderCategoryAttributeRootInterface[]
  ) => {
    if (!this.providerSettings?.category.attributeSupporting) {
      return;
    }

    const storeFoundCategoryMapping = getStoreCategoryMapping(
      this.store,
      this.product?.CategoryId ?? '',
      this.providerProduct.MarketplaceIdentity,
      this.providerProduct.ProviderId
    );

    if (
      storeFoundCategoryMapping?.ProviderCategory ===
      this.providerProduct.Category
    ) {
      attributeList.map((attribute) => {
        const found = storeFoundCategoryMapping?.DefaultValues.find(
          (defValue) => defValue.NameId === attribute.Code
        );

        if (found) {
          attribute.Value = found.Value;
        }
      });

      this.matchingAutoComplete().attribute = true;
    }

    this.messagesFill();
    this.validation();
  };

  providerCategoriesAttributesRequest(
    providerCategory: string,
    autoMatching: boolean
  ) {
    if (this.providerProduct && providerCategory.length > 0) {
      const request = {
        ProviderId: this.providerProduct.ProviderId,
        CategoryCode: providerCategory,
        MarketplaceIdentity: this.providerProduct.MarketplaceIdentity,
      };
      this.providerCategoryAttributesService
        .getList(request)
        .pipe(takeUntil(this.destroy$))
        .subscribe((attributeList) => {
          if (this.providerProduct.Id.length === 0 && autoMatching) {
            if (attributeList.length !== 0) {
              this.autoAttributeMatching(attributeList);
            }
          }

          prepareAttributes(attributeList, this.providerProduct);

          const tempAttributeList = [...attributeList];

          this.providerProduct.Attributes = providerAttributeEditFunction(
            this.providerProduct.Attributes,
            attributeList
          );

          this.providerCategoryAttributes.set(tempAttributeList);

          this.checkAttributes();
        });
    }
  }

  providerCategoriesGetRequest = (categoryCode: string) => {
    if (!this.providerProduct || categoryCode.length === 0) {
      return;
    }

    this.providerCategoriesService
      .get({
        ProviderId: this.providerProduct?.ProviderId,
        CategoryId: categoryCode,
        MarketplaceIdentity: this.providerProduct.MarketplaceIdentity,
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe((f) => {
        if (f && f.Items && f.Items.length > 0) {
          this.providerCategory = {
            Name: f.Items.at(0)?.Name ?? '',
            Code: f.Items.at(0)?.Code ?? '',
            Path: f.Items.at(0)?.Path ?? '',
            PathBuild: f.Items.at(0)?.PathBuild ?? [],
          };

          if (
            this.providerSettings &&
            this.providerSettings.category.attributeSupporting &&
            this.providerSettings.providerGroup !== ProviderGroupEnum.ECommerce
          ) {
            this.providerCategoriesAttributesRequest(
              this.providerProduct.Category ?? '',
              true
            );
          }

          this.validation();
        }
      });
  };

  openBrandSelection = () => {
    this.brandSelectionRef = this.dialogService.open(BrandSelectionComponent, {
      header: `Marka Seçimi`,
      width: '60vw',
      modal: true,
      closable: true,
      data: {
        providerId: this.providerProduct?.ProviderId,
        marketplaceIdentity: this.providerProduct?.MarketplaceIdentity,
      },
      breakpoints: {
        '960px': '70vw',
        '640px': '90vw',
      },
    });
    this.subscription = this.brandSelectionRef.onClose
      .pipe(takeUntil(this.destroy$))
      .subscribe((f: ProviderBrandsSearchResponseData) => {
        this.subscription?.unsubscribe();
        if (f) {
          this.matchingAutoComplete().brand = false;
          this.providerProduct?.setBrandName(f.Name);
          this.providerProduct?.setBrandId(f.Code);
          this.messagesFill();
          this.validation();
        }
      });
  };

  openCategoriesSelection = () => {
    if (this.providerSettings?.category.supporting) {
      this.categorySelectionRef = this.dialogService.open(
        CategoriesSelectionComponent,
        {
          header: `Kategori Seçimi`,
          width: '50vw',
          modal: true,
          closable: true,
          data: {
            providerId: this.providerProduct?.ProviderId,
            marketplaceIdentity: this.providerProduct?.MarketplaceIdentity,
          },
          breakpoints: {
            '960px': '70vw',
            '640px': '90vw',
          },
        }
      );
      this.subscription = this.categorySelectionRef.onClose
        .pipe(takeUntil(this.destroy$))
        .subscribe((f: ProviderCategoriesGetResponseItemsInterface) => {
          this.subscription?.unsubscribe();
          if (f && this.providerProduct) {
            this.matchingAutoComplete().category = false;
            this.matchingAutoComplete().attribute = false;
            this.providerCategory = f;
            this.providerProduct.Category = f.Code;
            this.providerProduct.Attributes = [];
            this.newAttributes$.set(true);
            this.providerCategoriesAttributesRequest(f.Code, false);
            this.messagesFill();
            this.providerCategoryAttributes.set([]);
            this.validation();
          }
        });
    }
  };

  openCategoriesAttributes = () => {
    if (this.providerSettings?.category.attributeSupporting) {
      this.categoryAtrributeRef = this.dialogService.open(
        CategoryAttributesMatchingComponent,
        {
          header: `Kategori  Özellik Eşleştirme`,
          width: '60vw',
          modal: true,
          closable: true,
          data: {
            attributes: this.providerCategoryAttributes(),
            providerProduct: this.providerProduct,
          },
          breakpoints: {
            '960px': '45vw',
            '640px': '90vw',
          },
        }
      );
      this.subscription = this.categoryAtrributeRef.onClose
        .pipe(takeUntil(this.destroy$))
        .subscribe((f: ProviderProductAttribute[]) => {
          this.subscription?.unsubscribe();
          if (f && this.providerProduct) {
            this.matchingAutoComplete().attribute = false;
            this.providerProduct.Attributes = f;
            this.newAttributes$.set(false);
            this.checkAttributes();
            this.messagesFill();

            this.validation();
          }
        });
    }
  };

  validation = () => {
    clearTimeout(this.validationSetTimeId);
    this.validationSetTimeId = setTimeout(() => {
      this.providerProduct?.validationFunction(
        this.providerCategoryAttributes()
      );
    }, 100);
  };
  protected readonly ProviderGroupEnum = ProviderGroupEnum;
}
